module.exports = __webpack_public_path__ + "img/p-bg.523071ad.png";